/**
 * Filter Definitions Index
 *
 * Exports all available filter definitions
 */

import { FilterDefinition } from '../types';
import { nodeTypeFilter } from './nodeTypeFilter';
import { nodeIdFilter } from './nodeIdFilter';
import { nameFilter } from './nameFilter';
import { domainFilter } from './domainFilter';
import { edgeFilter } from './edgeFilter';
import { flagFilter } from './flagFilter';

/**
 * All available filter definitions
 */
export const allFilterDefinitions: Record<string, FilterDefinition> = {
  nodeType: nodeTypeFilter,
  nodeId: nodeIdFilter,
  name: nameFilter,
  domain: domainFilter,
  edge: edgeFilter,
  flag: flagFilter,
};

// Re-export individual filters for direct import
export { nodeTypeFilter } from './nodeTypeFilter';
export { nodeIdFilter } from './nodeIdFilter';
export { nameFilter } from './nameFilter';
export { domainFilter } from './domainFilter';
export { edgeFilter } from './edgeFilter';
export { flagFilter, HAS_SVARAS_FLAG, FLAG_LABELS } from './flagFilter';
